'use client';

import { FC } from 'react';
import Link from 'next/link';
import { CHALLENGES_URL } from '@puzzlio/core';
import { BodyBase, BodySubheading } from '@puzzlio/ui';
import { cn } from '@/app/lib/utils';
import { useShowChallengePitch, useThisWeeksChallenges, useTrackChallengePitch } from '@/app/hooks/useChallenges';
import { ChallengeCard } from './ChallengeCard';

/**
 * This week's weekly challenges, under the home page's game cards: progress for a subscriber, the pitch
 * for anyone else. Absent in a week without any, and until the week's list and the player's plays load.
 */
export const WeeklyChallengesStrip: FC<{ className?: string }> = ({ className }) => {
  const challenges = useThisWeeksChallenges();
  const showPitch = useShowChallengePitch();
  useTrackChallengePitch(showPitch && !!challenges?.length);
  if (!challenges?.length) return null;

  return (
    <section
      className={cn('flex w-full max-w-6xl flex-col items-center gap-4', className)}
      data-testid="weekly-challenges-strip"
    >
      <BodySubheading className="text-center">This Week&apos;s Challenges</BodySubheading>
      {showPitch && (
        <BodyBase className="max-w-[520px] text-center opacity-60">
          A tougher puzzle each week, for players who&apos;ve mastered the dailies.
        </BodyBase>
      )}
      <div className="flex flex-wrap justify-center gap-4">
        {challenges.map((challenge) => (
          <ChallengeCard
            key={challenge.boardId}
            challenge={challenge}
            status={challenge.status}
            locked={showPitch}
            className="w-72"
          />
        ))}
      </div>
      <Link prefetch={false} href={CHALLENGES_URL} className="font-quicksand font-bold underline underline-offset-2">
        All weekly challenges
      </Link>
    </section>
  );
};
